import React from "react";
import vehicleSchemaExterne from "../../../doc/schemas/vehicle/vehicle_externe.json";
import vehicleSchemaInterne from "../../../doc/schemas/vehicle/vehicle_interne.json";
import SchemasInterpretor from "./SchemasInterpretor";

const DocVehicle = () => {
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <h1 className="mb-4">Documentation Véhicule</h1>
          <SchemasInterpretor
            leftSchema={vehicleSchemaExterne}
            rightSchema={vehicleSchemaInterne}
            leftTitle="Schéma Véhicule Externe"
            rightTitle="Schéma Véhicule Interne"
          />
        </div>
        {/* <div className="col-12">
          <FormGenerator schema={vehicleSchemaExterne} />
        </div> */}
      </div>
    </div>
  );
};

export default DocVehicle;
